<div class="page-layout blank p-24 inner-scroll">
  <iframe *ngIf="hostedPageUrl" [src]="hostedPageUrl" id="cb_hosted_page"></iframe>
  <div id="recurly" *ngIf="!business.isLegacy">
    <div *ngIf="pmInfo">
      <div id="pm-info">
        <span>Saved {{pmInfo.cardType ? 'Credit Card' : 'Bank Account'}}</span>
        <div *ngIf="pmInfo">
          <div *ngIf="pmInfo.cardType" [attr.enabled]="!changes?.remove">
            <div id="card-type">
              <img [src]="cardImg">
              <span>{{pmInfo.firstSix}}...{{pmInfo.lastFour}}</span>
            </div>
            <span>Expires: {{pmInfo.expires}}</span>
          </div>
          <div *ngIf="pmInfo.accountType" [attr.enabled]="!changes?.remove">
            <span><b>Bank Name:</b> {{pmInfo.routingNumberBank}}</span>
            <span><b>Routing Number:</b> {{pmInfo.routingNumber}}</span>
            <span><b>Account Number:</b> ...{{pmInfo.lastFour}}</span>
            <span><b>Account Type:</b> {{pmInfo.accountType}}</span>
            <span><b>Owner Name:</b> {{pmInfo.nameOnAccount}}</span>
          </div>
          <i [ngClass]="changes?.remove ? 'fa-solid fa-trash-undo' : 'fa-solid fa-trash-can'" (click)="onDelete($event)"></i>
        </div>
        <span *ngIf="!pmInfo">No cards on file</span>
      </div>
    </div>
    <div *ngIf="showAdd" id="recurly-payment">
      <div id="rec-add">
        <button (click)="bankClick()" [attr.selected]="addBank">
          <i class="fa-solid fa-building-columns"></i>
          Add Bank Account
        </button>
        <button (click)="cardClick()" [attr.selected]="addCard">
          Add Credit Card
          <i class="fa-solid fa-credit-card"></i>
        </button>
      </div>
      <div [hidden]="!addCard && !addBank">
        <form id="recurly-payment-form" [formGroup]="cardPaymentInfoForm">
          <div>
            <input type="text" data-recurly="first_name" placeholder="First Name" formControlName="first_name" [attr.valid]="cardPaymentInfoForm.controls.first_name.valid || !cardPaymentInfoForm.controls.first_name.touched" cap>
            <input type="text" data-recurly="last_name" placeholder="Last Name" formControlName="last_name" [attr.valid]="cardPaymentInfoForm.controls.last_name.valid || !cardPaymentInfoForm.controls.last_name.touched" cap>
          </div>
          <input maxlength="16" type="text" data-recurly="phone" required placeholder="Phone Number" mask="(000) 000-0000||0 (000) 000-0000" formControlName="phone"
            [attr.valid]="cardPaymentInfoForm.controls.phone.valid || !cardPaymentInfoForm.controls.phone.touched" (keydown)="onNumKeyDown($event)">
          <input id="rpm-addr1" type="text" data-recurly="address1" placeholder="Address 1" formControlName="address1" [attr.valid]="cardPaymentInfoForm.controls.address1.valid || !cardPaymentInfoForm.controls.address1.touched" cap>
          <app-address-input for="rpm-addr1" (addressSelected)="addressSelected($event)"></app-address-input>
          <input type="text" data-recurly="address2" placeholder="Address 2" formControlName="address2">
          <div>
            <input type="text" data-recurly="city" placeholder="City" formControlName="city" [attr.valid]="cardPaymentInfoForm.controls.city.valid || !cardPaymentInfoForm.controls.city.touched" cap>
            <input maxlength="2" type="text" data-recurly="state" placeholder="State" formControlName="state" [attr.valid]="cardPaymentInfoForm.controls.state.valid || !cardPaymentInfoForm.controls.state.touched" upper>
          </div>
          <div>
            <input maxlength="5" type="text" data-recurly="postal_code" placeholder="Zip Code" formControlName="postal_code" [attr.valid]="cardPaymentInfoForm.controls.postal_code.valid || !cardPaymentInfoForm.controls.postal_code.touched">
            <input maxlength="2" type="text" data-recurly="country" placeholder="Country" formControlName="country" [attr.valid]="cardPaymentInfoForm.controls.country.valid || !cardPaymentInfoForm.controls.country.touched" upper>
          </div>
          <div *ngIf="addBank">
            <form id="recurly-bank-form" [formGroup]="bankPaymentInfoForm">
              <div>
                <label for="ac-type">Account Type:</label>
                <select id="ac-type" data-recurly="account_type" formControlName="account_type" [attr.valid]="bankPaymentInfoForm.controls.account_type.valid || !bankPaymentInfoForm.controls.account_type.touched">
                  <option selected>checking</option>
                  <option>savings</option>
                </select>
              </div>
              <input maxlength="9" type="text" data-recurly="routing_number" placeholder="Routing Number" formControlName="routing_number" (keydown)="onNumKeyDown($event)" [attr.valid]="bankPaymentInfoForm.controls.routing_number.valid || !bankPaymentInfoForm.controls.routing_number.touched">
              <input maxlength="17" type="text" data-recurly="account_number" placeholder="Account Number" formControlName="account_number" (keydown)="onNumKeyDown($event)" [attr.valid]="bankPaymentInfoForm.controls.account_number.valid || !bankPaymentInfoForm.controls.account_number.touched">
              <input maxlength="17" type="text" data-recurly="account_number_confirmation" placeholder="Confirm Account Number" formControlName="account_number_confirmation" (keydown)="onNumKeyDown($event)" [attr.valid]="bankPaymentInfoForm.controls.account_number_confirmation.valid || !bankPaymentInfoForm.controls.account_number_confirmation.touched">
              <input type="text" data-recurly="name_on_account" placeholder="Name on Account" formControlName="name_on_account" [attr.valid]="bankPaymentInfoForm.controls.name_on_account.valid || !bankPaymentInfoForm.controls.name_on_account.touched" cap>
            </form>
          </div>
        </form>

        <div id="recurly-payment-elements"></div>
        <input type="hidden" name="recurly-token" data-recurly="token">
      </div>

      <span class="rpm-error" *ngFor="let e of errors">{{e}}</span>
      <button id="submit" (click)="onSubmit($event)" [attr.enabled]="bankPaymentInfoForm.valid || (cardPaymentInfoForm.valid && cardValid)">
        Submit
        <i class="fa-solid fa-share"></i>
      </button>
    </div>
  </div>
</div>